import * as React from "react";

export const makeWithContext = Consumer => WrappedComponent => props =>
  <Consumer>
    {
      injectedProps => <WrappedComponent {...props} {...injectedProps} />
    }
  </Consumer>
